import { useState, useMemo } from "react";
import { Modal, Tab, Button } from "semantic-ui-react";

type ModPackageOrderDetailProps = {
  open: boolean;
  onClose: () => void;
  data?: Record<string, any>[];
  packageTypeOptions?: Record<string, any>[];
};

type TestsPaneProps = {
  data?: Record<string, any>[];
};

type InfoPaneProps = {
  data?: Record<string, any>[];
};

// ==================== Tab 1: รายการตรวจ ====================
const TestsPane = (props: TestsPaneProps) => {
  const packages = props.data ?? [];

  return (
    <Tab.Pane attached={false} style={{ border: "none", boxShadow: "none", padding: "16px 0" }}>
      {packages.map((pkg, pkgIndex) => {
        const activeItems = (pkg.items ?? []).filter((item: any) => item.active);

        return (
          <div
            key={pkg.id ?? pkgIndex}
            style={{ marginBottom: pkgIndex < packages.length - 1 ? 16 : 0 }}
          >
            {/* Section label: package_type_name */}
            {pkg.package_type_name && (
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: 6,
                  color: pkg.package_type_name === "Package" ? "#5D8439" : "#FE9500",
                }}
              >
                {pkg.package_type_name}
              </div>
            )}

            {/* Items list */}
            {activeItems.map((item: any, index: number) => (
              <div key={item.id ?? index} style={{ padding: "4px 2.5rem" }}>
                <div style={{ fontWeight: 600, fontSize: 14, color: "#333" }}>
                  {item.product_name}
                </div>
                {item.product_name_en && (
                  <div style={{ fontSize: 12, color: "#999", marginTop: 2 }}>
                    {item.product_name_en}
                  </div>
                )}
              </div>
            ))}
          </div>
        );
      })}
    </Tab.Pane>
  );
};

// ==================== Tab 2: ข้อมูลเพิ่มเติม ====================
const InfoPane = (props: InfoPaneProps) => {
  const packages = props.data ?? [];

  return (
    <Tab.Pane attached={false} style={{ border: "none", boxShadow: "none", padding: "16px 0" }}>
      {packages.map((pkg, pkgIndex) => (
        <div
          key={pkg.id ?? pkgIndex}
          style={{ marginBottom: pkgIndex < packages.length - 1 ? 16 : 0 }}
        >
          {pkg.package_type_name && (
            <div
              style={{
                fontWeight: 600,
                fontSize: 13,
                marginBottom: 6,
                color: pkg.package_type_name === "Package" ? "#5D8439" : "#FE9500",
              }}
            >
              {pkg.package_type_name}
            </div>
          )}
          <div style={{ padding: "4px 2.5rem" }}>
            <div dangerouslySetInnerHTML={{ __html: pkg.recommendation || "-" }} />
          </div>
        </div>
      ))}
    </Tab.Pane>
  );
};

// ==================== Main Modal Component ====================
const ModPackageOrderDetail = (props: ModPackageOrderDetailProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const formattedData = useMemo(() => {
    return (props.data ?? []).map((item) => {
      const foundPackageType = (props.packageTypeOptions ?? []).find(
        (option) => option?.value === item?.package_type,
      );

      return { ...item, package_type_name: foundPackageType?.text };
    });
  }, [props.data, props.packageTypeOptions]);

  const handleTabChange = (_e: any, data: any) => {
    setActiveIndex(data.activeIndex ?? 0);
  };

  const panes = [
    {
      menuItem: "รายการตรวจ",
      render: () => <TestsPane data={formattedData} />,
    },
    {
      menuItem: "ข้อมูลเพิ่มเติม",
      render: () => <InfoPane data={formattedData} />,
    },
  ];

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      size="small"
      closeIcon
      className="mod-package-detail"
      style={{ borderRadius: 8 }}
    >
      <Modal.Content style={{ padding: "8px 24px 0" }}>
        <Tab
          menu={{
            secondary: true,
            pointing: true,
            style: { borderBottom: "1px solid #eee", marginBottom: 0 },
          }}
          panes={panes}
          activeIndex={activeIndex}
          onTabChange={handleTabChange}
        />
      </Modal.Content>

      <Modal.Actions style={{ borderTop: "1px solid #f0f0f0" }}>
        <Button onClick={props.onClose} color="grey">
          ปิดหน้าต่าง
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModPackageOrderDetail;
